import React from "react";

const Pagination = ({ currentPage, totalPages, prev, paginate, next }) => {
  if (totalPages === 0) {
    return null;
  }

  const pageNumbers = [];
  for (let page = 1; page <= totalPages; page += 1) {
    pageNumbers.push(page);
  }

  return (
    <nav aria-label="Page navigation example">
      <ul className="inline-flex flex-wrap space-x-2">
        <li>
          <button
            onClick={prev}
            className="py-2 px-3 ml-0 leading-tight hover:bg-indigo-500 hover:text-white text-gray-500 bg-white rounded-l-lg border border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
          >
            {"<"}
          </button>
        </li>
        {pageNumbers.map((page, index) => (
          <li key={index}>
            <button
              onClick={() => {
                paginate(page);
              }}
              className={`py-2 px-3 ml-0 leading-tight hover:bg-indigo-600 hover:text-white ${
                currentPage === page
                  ? "bg-indigo-500 text-white"
                  : "bg-white text-gray-500"
              } rounded-lg border border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white`}
            >
              {page}
            </button>
          </li>
        ))}
        <li>
          <button
            onClick={next}
            className="py-2 px-3 ml-0 leading-tight hover:bg-indigo-600 hover:text-white text-gray-500 bg-white rounded-r-lg border border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
          >
            {">"}
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
